import React, { useState } from 'react';
import { Form, Modal, Button } from 'rsuite';
import { alert } from '../../../helpers/rsuite/Alerts';
import { cuotitasStoreService } from '../../../services';
import { getSessionUserByStorage, getStoreByStorage } from '../../../helpers';
import { getTemplate } from '../../../components/templates/Email';
import { errorMapper, getDataError } from '../../../helpers/ErrorMappers';
import { asyncService } from '../../../helpers/AsyncService';

//
// Custom error list
//
// TODO change list to better description like dictionary
// const errorList = {
//     10010601: 'Por favor verifique la documentación ingresada e intente con un documento de menor peso. '
// };

const warningList = {
    NotFoundBill: 'No se encontró una factura cargada',
    NotSigned: 'Faltan datos biométricos'
};

//
// Confirm Loan
//
export function ConfirmLoan ({ show, onHide, fetchCards, request, tab }) {
    //
    // States
    //

    // Form values states

    // Loading state
    const [isLoading, setIsLoading] = useState(false);
    const store = getStoreByStorage();
    const idStore = store.id;
    const sessionUser = getSessionUserByStorage();

    //
    // Funcions
    //

    const createUser = () => {
        setIsLoading(true);
        // confirmLoanLoop(request?.id, qs)
        return asyncService((qss) => cuotitasStoreService.confirmLoanRequest(idStore, request?.id, qss, { tab }))
            .then(response => {
                alert('success', '¡Préstamo confirmado!', 5000);
                onHide();
                return fetchCards();
            })
            .catch(e => {
                console.error(e);
                // const dataError = JSON.parse(e?.message);
                // let msg = 'Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.';
                const msg = errorMapper(e);
                if (msg?.message?.length && warningList[msg?.message]) {
                    return alert('warning', warningList[msg?.message]);
                }

                const submitToast = () => submitToastReport(e);
                return alert(msg?.type, msg?.message, 0, 'topCenter', submitToast);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    //
    // Report error by email
    //
    // eslint-disable-next-line react/no-multi-comp
    const submitToastReport = (error) => {
        const dataError = getDataError(error);
        const message = JSON.stringify(dataError) || '';
        const date = new Date().toLocaleDateString();
        const dateTime = new Date().toLocaleTimeString();

        const data = {
            date,
            dateTime,
            store: store?.name || '',
            fullname: sessionUser?.formattedName || '',
            errorCode: dataError?.extra?.code || dataError?.task?.result?.code || dataError?.code,
            errorMessage: message?.replaceAll('&', '')?.replaceAll('?', '').replaceAll('=', ''),
            documentClient: request?.document || '',
            fullnameClient: request?.formattedName || '',
            idOfferExternal: request?.idOfferExternal || '',
            idRequestExternal: request?.idExternal || '',
            idRequest: request?.id || '',
            idSignRequest: request?.idSignRequest || '',
            traceId: dataError?.extra?.trace || dataError?.trace || '',
            creditNumber: request?.creditNumber || '',
        };

        return (<a href={getTemplate(data)} style={ { textDecoration: 'underline' } }>Reportar por mail</a>);
    };

    return (
        <Modal
            // show={show}
            open={show}
            onClose={onHide}
            className={`${show ? 'show in' : ''}`}
            aria-labelledby='user-create-modal'
        >
            <Modal.Header closeButton>
                <Modal.Title id='user-create-modal'>
                    {!isLoading && (<span>Confirmar préstamo</span>)}
                    {isLoading && <span>Confirmando préstamo...</span>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className='py-1'>
                {!isLoading && (
                    <div className='row justify-content-center m-0'>
                        {/* <div className='row m-0'> */}
                        <div className='col-lg-8'>
                            <Form
                                fluid
                                // formValue={{ name, lastname, document, email }}
                                onChange={() => {}}
                            />
                        </div>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className='mt-4'>
                <div>
                    <Button appearance='primary' disabled={isLoading} onClick={createUser} >Aceptar</Button>
                    <Button appearance='subtle' disabled={isLoading} onClick={onHide} >Cancelar</Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};
